<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card
      flat
      :loading="loading"
      class="card-fill-height"
    >
      <v-card-text>
        <v-icon @click="drawer = false"> close </v-icon>
      </v-card-text>
      <v-card-title> Edit Review </v-card-title>
      <v-card-subtitle>
        <v-row dense>
          <v-col
            v-if="review.orderId"
            cols="auto"
          >
            <span class="font-weight-bold">Order Id</span> {{ review.orderId }}
          </v-col>
          <v-col
            v-if="review.designRequestId"
            cols="auto"
          >
            <span class="font-weight-bold">Design Request Id</span> {{ review.designRequestId }}
          </v-col>
          <v-col cols="auto">
            <span class="font-weight-bold">Rating</span> {{ review.stars }}
          </v-col>
          <v-col cols="auto">
            <span class="font-weight-bold">Email</span> {{ review.email }}
          </v-col>
        </v-row>
      </v-card-subtitle>
      <v-card-text class="py-0">
        <v-tabs
          v-model="tab"
          fixed-tabs
        >
          <v-tab> Details </v-tab>
          <v-tab> Images ({{ images.length }}) </v-tab>
          <v-tab v-if="review.includeProjectImages">Project </v-tab>
        </v-tabs>
      </v-card-text>
      <v-divider />
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <template v-if="tab == 0">
              <v-col cols="12">
                <v-select
                  v-model="review.statusId"
                  :items="review_statuses"
                  label="Status"
                  item-value="id"
                  item-text="name"
                  outlined
                  hide-details="auto"
                  :rules="[$rules.required]"
                />
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="review.stars"
                  :items="ratings"
                  label="Rating"
                  outlined
                  hide-details="auto"
                  :rules="[$rules.required]"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="review.name"
                  label="Name"
                  outlined
                  hide-details="auto"
                  :rules="[$rules.required]"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="review.company"
                  label="Company"
                  outlined
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="review.comment"
                  label="Comment"
                  outlined
                  hide-details="auto"
                  :rules="[$rules.required]"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="review.longComment"
                  label="Long Comment"
                  outlined
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  v-model="review.featured"
                  class="mt-0 pt-0"
                  label="Featured"
                  outlined
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  v-model="review.featuredPrint"
                  class="mt-0 pt-0"
                  label="Featured Print"
                  outlined
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  v-model="review.includeProjectImages"
                  class="mt-0 pt-0"
                  label="Include project images?"
                  outlined
                  hide-details="auto"
                />
              </v-col>
            </template>
            <template v-if="tab == 1">
              <v-col
                v-for="(item, i) in images"
                :key="i"
                cols="12"
              >
                <v-card>
                  <v-card-text>
                    <v-img
                      :src="item.url"
                      class="mb-4"
                    />
                    <v-text-field
                      v-model="item.sortOrder"
                      outlined
                      dense
                      label="Sort Order"
                    />
                    <v-checkbox
                      v-model="item.ignore"
                      label="Ignore?"
                      class="mt-0 pt-0"
                      hide-details
                    />
                  </v-card-text>
                </v-card>
              </v-col>
            </template>
            <template v-if="tab == 2">
              <v-col
                v-for="(item, i) in review.projectImages"
                :key="i"
                cols="12"
              >
                <v-card>
                  <v-card-text>
                    <v-img
                      :src="item"
                      class="mb-4"
                      contain
                    />
                  </v-card-text>
                </v-card>
              </v-col>
            </template>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { cloneDeep, sortBy } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  name: 'ReviewEdit',

  components: {},

  data() {
    return {
      loading: false,
      valid: false,
      saving: false,
      drawer: false,
      ratings: [1, 2, 3, 4, 5],
      tab: 0
    };
  },

  computed: {
    review: {
      get() {
        return this.$store.getters['reviews/edit_review'] || {};
      },
      set(val) {
        this.$store.dispatch('reviews/edit', val);
      }
    },
    images() {
      return sortBy(this.review.images || [], 'sortOrder');
    },
    ...mapGetters({
      reviews: 'reviews/list',
      review_statuses: 'lookup/review_statuses'
    })
  },

  async mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.REVIEW_EDIT_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.REVIEW_EDIT_SHOW, (data) => {
      this.loadData(data.id);
      this.drawer = true;
    });
  },

  methods: {
    loadData(id) {
      this.loading = true;
      Promise.all([
        this.$store.dispatch('reviews/set', cloneDeep(this.reviews.find((x) => x.orderId === id)))
      ])
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('reviews/update', this.review)
        .then(() => {
          this.$emit('save');
          this.$root.$snackbarSuccess('Review saved');
          this.drawer = false;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
